export default __webpack_public_path__ + "static/media/group-de-pessoas.efae6a66.png";